import { LoadingProps } from '@/types/component-props';

export default function LoadingSpinner({ showSpinner = true, fullScreen }: Omit<LoadingProps, 'message'> & { fullScreen?: boolean }) {
  const displayMessage = 'Loading...';
  
  return (
    <div 
      className="flex flex-col items-center justify-center min-h-screen w-full"
      data-testid="loading-spinner"
      data-fullscreen={fullScreen ? "true" : undefined}
      role="status"
    >
      {showSpinner && <div className="h-8 w-8 rounded-full bg-gray-200 animate-spin mb-2" />}
      {displayMessage && <div className="text-gray-400 text-xs mt-2">{displayMessage}</div>}
    </div>
  );
}

// Skeleton component for member photo loading
export function MemberPhotoSkeleton() {
  return (
    <div className="h-10 w-10 rounded-full bg-gray-200 animate-pulse flex items-center justify-center">
      <div className="h-6 w-6 bg-gray-300 rounded-full"></div>
    </div>
  );
} 